/**
 * 런타임 설정 — **목 ↔ 실서버 전환의 유일한 지점**.
 *
 * 실서버로 붙일 때 바꾸는 것은 env 뿐이다(코드 수정 없음):
 *
 *   VITE_USE_MOCK=0
 *   VITE_WS_URL=wss://trans.example/ws      (미지정 시 현재 오리진 + /ws)
 *   VITE_API_BASE=/api                       (동일 오리진 전제 — §10.2)
 *
 * 프로덕션 빌드는 목을 아예 포함하지 않는다: `USE_MOCK` 이 정적 false 로
 * 접히면 `import('../mock/client')` 호출부가 통째로 tree-shake 된다.
 */

const env = import.meta.env

/** 개발 기본값은 목. 실서버 붙이려면 VITE_USE_MOCK=0. */
export const USE_MOCK: boolean = env.DEV && env['VITE_USE_MOCK'] !== '0'

export const API_BASE: string = env['VITE_API_BASE'] ?? '/api'

/**
 * §10.1 WS 경로 — **배포된 nginx 가 정본이다**.
 *
 *   호스트 오디오: `/host/ws/{room}`
 *   뷰어 이벤트:   `/relay/ws/{room}`
 *
 * 이 두 경로를 임의로 바꿀 수 없다: 프록시 박스의 location 블록이 이 접두사에
 * **3600s 타임아웃 + 무버퍼링**을 걸어 둔다. 다른 경로를 쓰면 기본 60s
 * 타임아웃에 걸려 **조용한 회의에서 소켓이 끊긴다**(발화 사이 무음 구간에는
 * 프레임이 뜸해진다). 서버 라우트도 같은 이유로 이 경로에 맞춰져 있다.
 */
export function wsPath(role: 'host' | 'viewer', room: string): string {
  const prefix = role === 'host' ? '/host/ws' : '/relay/ws'
  return `${prefix}/${encodeURIComponent(room)}`
}

/** WS 엔드포인트. 미지정 시 현재 오리진(동일 오리진 전제 §10.2). */
export function wsUrl(path: string): string {
  const configured = env['VITE_WS_URL']
  if (configured) return `${String(configured).replace(/\/$/, '')}${path}`
  if (typeof location === 'undefined') return `ws://localhost:9100${path}`
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${location.host}${path}`
}

/** §10.1 WS 서브프로토콜 — 쿼리 스트링 금지, 키는 서브프로토콜로 전달. */
export function keyProtocol(key: string): string {
  return `trans.v1.${key}`
}

/** §8.3 접속 시 즉시 재생 건수. */
export const REPLAY_LIMIT = 100
/** §8.3 히스토리 페이지네이션 크기. */
export const HISTORY_PAGE = 200
